// frontend/src/services/membreteService.js
import plantillaService from './plantillaService';

const membreteService = {
  // Obtener todos los membretes
  getMembretes: async () => {
    return await plantillaService.getMembretes();
  },
  
  // Obtener membrete por ID
  getMembreteById: async (id) => {
    try {
      // Como no existe un endpoint específico, simulamos obteniendo todos y filtrando
      const membretes = await plantillaService.getMembretes();
      const membrete = membretes.find(m => m.id === parseInt(id));
      return membrete || null;
    } catch (error) {
      throw error;
    }
  }
};

export default membreteService;